// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__Ifoav","image":"Banner_image__2ro68"};